import { AppDownLoadAddress } from "@/utils/confiigUtils";
import { getShareParams, transformReqParams } from "@/utils/shareParamsMapping";
import { GetServerSideProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import PullNewServices from "@/service/pullNew.service";
interface IntentsCommonProps {
  moduleKey: string;
  inviteCode: string;
  imgUrl: string;
  redirectUrl: string;
  nickname?: string;
}

const IntentsCommon: NextPage<IntentsCommonProps> = ({
  moduleKey,
  inviteCode,
  imgUrl,
  redirectUrl,
  nickname,
}) => {
  const { t } = useTranslation("share");
  const router = useRouter();

  if (typeof window !== "undefined") {
    router.replace(
      redirectUrl || AppDownLoadAddress.HOME_PAGE_DOWNLOAD(inviteCode)
    );
  }

  return (
    <>
      <Head>
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content={t(`${moduleKey}-site-name`, { inviteCode })}
        />
        <meta
          property="og:title"
          content={t(`${moduleKey}-title`, { inviteCode, nickname })}
        />
        <meta
          property="og:description"
          content={t(`${moduleKey}-description`, { inviteCode, nickname })}
        />
        <meta property="og:image" content={imgUrl} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />

        <meta
          name="twitter:title"
          content={t(`${moduleKey}-title`, { inviteCode, nickname })}
        />
        <meta
          name="twitter:description"
          content={t(`${moduleKey}-description`, { inviteCode, nickname })}
        />
        <meta name="twitter:image" content={imgUrl} />
        <meta name="twitter:card" content="summary_large_image"></meta>

        <meta name="telegram:channel" content="@telegram" />

        <title>{t(`${moduleKey}-title`, { inviteCode, nickname })}</title>
      </Head>

      <div></div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const params = {
    moduleKey: "",
    inviteCode: "",
    imgUrl: "",
    redirectUrl: "",
    nickname: "",
  };

  try {
    const { t, p } = context.query;
    const { moduleKey, inviteCode } = transformReqParams(t as string);
    const { imgUrl, redirectUrl } = getShareParams(
      moduleKey,
      inviteCode,
      p as string,
      context.locale as string
    );
    params.moduleKey = moduleKey;
    params.inviteCode = inviteCode;
    params.redirectUrl = redirectUrl;
    params.imgUrl = imgUrl;

    const nickname = await PullNewServices.getInviter(inviteCode);
    params.nickname = nickname || "";
  } catch (error) {
    if (error instanceof Error) console.log(error.message);
  }

  return {
    props: {
      ...(await serverSideTranslations(context.locale as string, ["share"])),
      ...params,
    },
  };
};
export default IntentsCommon;
